module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/fiatdepositconfirmdialog/fiatdepositconfirmdialog.component.css
// module id = ./src/app/fiatdepositconfirmdialog/fiatdepositconfirmdialog.component.css
// module chunks = main